export interface TaxBracket {
  floor: number;
  rate: number;
}

// Federal tax brackets (2026 Single filing status).
export const FEDERAL_TAX_BRACKETS_SINGLE: TaxBracket[] = [
  { floor: 0, rate: 0.10 },
  { floor: 12_400, rate: 0.12 },
  { floor: 50_400, rate: 0.22 },
  { floor: 105_700, rate: 0.24 },
  { floor: 201_775, rate: 0.32 },
  { floor: 256_225, rate: 0.35 },
  { floor: 640_600, rate: 0.37 },
];

// State tax brackets (2026 Single filing status, all 50 states + DC).
// Source: Reserve TEY workbook, StateBrackets tab (Aug 2026).
export const STATE_TAX_BRACKETS_SINGLE: Record<string, TaxBracket[]> = {
  AK: [{ floor: 0, rate: 0.0 }],
  AL: [{ floor: 0, rate: 0.02 }, { floor: 500, rate: 0.04 }, { floor: 3_000, rate: 0.05 }],
  AR: [{ floor: 0, rate: 0.02 }, { floor: 4_600, rate: 0.039 }],
  AZ: [{ floor: 0, rate: 0.025 }],
  CA: [{ floor: 0, rate: 0.01 }, { floor: 11_079, rate: 0.02 }, { floor: 26_264, rate: 0.04 }, { floor: 41_452, rate: 0.06 }, { floor: 57_542, rate: 0.08 }, { floor: 72_724, rate: 0.093 }, { floor: 371_479, rate: 0.103 }, { floor: 445_771, rate: 0.113 }, { floor: 742_953, rate: 0.123 }, { floor: 1_000_000, rate: 0.133 }],
  CO: [{ floor: 0, rate: 0.044 }],
  CT: [{ floor: 0, rate: 0.02 }, { floor: 10_000, rate: 0.045 }, { floor: 50_000, rate: 0.055 }, { floor: 100_000, rate: 0.06 }, { floor: 200_000, rate: 0.065 }, { floor: 250_000, rate: 0.069 }, { floor: 500_000, rate: 0.0699 }],
  DC: [{ floor: 0, rate: 0.04 }, { floor: 10_000, rate: 0.06 }, { floor: 40_000, rate: 0.065 }, { floor: 60_000, rate: 0.085 }, { floor: 250_000, rate: 0.0925 }, { floor: 500_000, rate: 0.0975 }, { floor: 1_000_000, rate: 0.1075 }],
  DE: [{ floor: 0, rate: 0.0 }, { floor: 2_000, rate: 0.022 }, { floor: 5_000, rate: 0.039 }, { floor: 10_000, rate: 0.048 }, { floor: 20_000, rate: 0.052 }, { floor: 25_000, rate: 0.0555 }, { floor: 60_000, rate: 0.066 }],
  FL: [{ floor: 0, rate: 0.0 }],
  GA: [{ floor: 0, rate: 0.0519 }],
  HI: [{ floor: 0, rate: 0.014 }, { floor: 9_600, rate: 0.032 }, { floor: 14_400, rate: 0.055 }, { floor: 19_200, rate: 0.064 }, { floor: 24_000, rate: 0.068 }, { floor: 36_000, rate: 0.072 }, { floor: 48_000, rate: 0.076 }, { floor: 125_000, rate: 0.079 }, { floor: 175_000, rate: 0.0825 }, { floor: 225_000, rate: 0.09 }, { floor: 275_000, rate: 0.1 }, { floor: 325_000, rate: 0.11 }],
  IA: [{ floor: 0, rate: 0.038 }],
  ID: [{ floor: 0, rate: 0.0 }, { floor: 4_811, rate: 0.053 }],
  IL: [{ floor: 0, rate: 0.0495 }],
  IN: [{ floor: 0, rate: 0.0295 }],
  KS: [{ floor: 0, rate: 0.052 }, { floor: 23_000, rate: 0.0558 }],
  KY: [{ floor: 0, rate: 0.035 }],
  LA: [{ floor: 0, rate: 0.03 }],
  MA: [{ floor: 0, rate: 0.05 }, { floor: 1_083_150, rate: 0.09 }],
  MD: [{ floor: 0, rate: 0.02 }, { floor: 1_000, rate: 0.03 }, { floor: 2_000, rate: 0.04 }, { floor: 3_000, rate: 0.0475 }, { floor: 100_000, rate: 0.05 }, { floor: 125_000, rate: 0.0525 }, { floor: 150_000, rate: 0.055 }, { floor: 250_000, rate: 0.0575 }, { floor: 500_000, rate: 0.0625 }, { floor: 1_000_000, rate: 0.065 }],
  ME: [{ floor: 0, rate: 0.058 }, { floor: 27_399, rate: 0.0675 }, { floor: 64_849, rate: 0.0715 }],
  MI: [{ floor: 0, rate: 0.0425 }],
  MN: [{ floor: 0, rate: 0.0535 }, { floor: 33_310, rate: 0.068 }, { floor: 109_430, rate: 0.0785 }, { floor: 203_150, rate: 0.0985 }],
  MO: [{ floor: 0, rate: 0.0 }, { floor: 1_348, rate: 0.02 }, { floor: 2_696, rate: 0.025 }, { floor: 4_044, rate: 0.03 }, { floor: 5_392, rate: 0.035 }, { floor: 6_740, rate: 0.04 }, { floor: 8_088, rate: 0.045 }, { floor: 9_436, rate: 0.047 }],
  MS: [{ floor: 0, rate: 0.0 }, { floor: 10_000, rate: 0.04 }],
  MT: [{ floor: 0, rate: 0.047 }, { floor: 47_500, rate: 0.0565 }],
  NC: [{ floor: 0, rate: 0.0399 }],
  ND: [{ floor: 0, rate: 0.0 }, { floor: 48_475, rate: 0.0195 }, { floor: 244_825, rate: 0.025 }],
  NE: [{ floor: 0, rate: 0.0246 }, { floor: 4_130, rate: 0.0351 }, { floor: 24_760, rate: 0.0455 }],
  NH: [{ floor: 0, rate: 0.0 }],
  NJ: [{ floor: 0, rate: 0.014 }, { floor: 20_000, rate: 0.0175 }, { floor: 35_000, rate: 0.035 }, { floor: 40_000, rate: 0.0553 }, { floor: 75_000, rate: 0.0637 }, { floor: 500_000, rate: 0.0897 }, { floor: 1_000_000, rate: 0.1075 }],
  NM: [{ floor: 0, rate: 0.015 }, { floor: 5_500, rate: 0.032 }, { floor: 16_500, rate: 0.043 }, { floor: 33_500, rate: 0.047 }, { floor: 66_500, rate: 0.049 }, { floor: 210_000, rate: 0.059 }],
  NV: [{ floor: 0, rate: 0.0 }],
  NY: [{ floor: 0, rate: 0.039 }, { floor: 8_500, rate: 0.044 }, { floor: 11_700, rate: 0.0515 }, { floor: 13_900, rate: 0.054 }, { floor: 80_650, rate: 0.059 }, { floor: 215_400, rate: 0.0685 }, { floor: 1_077_550, rate: 0.0965 }, { floor: 5_000_000, rate: 0.103 }, { floor: 25_000_000, rate: 0.109 }],
  OH: [{ floor: 0, rate: 0.0 }, { floor: 26_050, rate: 0.0275 }],
  OK: [{ floor: 0, rate: 0.0 }, { floor: 3_750, rate: 0.025 }, { floor: 4_900, rate: 0.035 }, { floor: 7_200, rate: 0.045 }],
  OR: [{ floor: 0, rate: 0.0475 }, { floor: 4_550, rate: 0.0675 }, { floor: 11_400, rate: 0.0875 }, { floor: 125_000, rate: 0.099 }],
  PA: [{ floor: 0, rate: 0.0307 }],
  RI: [{ floor: 0, rate: 0.0375 }, { floor: 82_050, rate: 0.0475 }, { floor: 186_450, rate: 0.0599 }],
  SC: [{ floor: 0, rate: 0.0 }, { floor: 3_640, rate: 0.03 }, { floor: 18_230, rate: 0.06 }],
  SD: [{ floor: 0, rate: 0.0 }],
  TN: [{ floor: 0, rate: 0.0 }],
  TX: [{ floor: 0, rate: 0.0 }],
  UT: [{ floor: 0, rate: 0.045 }],
  VA: [{ floor: 0, rate: 0.02 }, { floor: 3_000, rate: 0.03 }, { floor: 5_000, rate: 0.05 }, { floor: 17_000, rate: 0.0575 }],
  VT: [{ floor: 0, rate: 0.0335 }, { floor: 49_400, rate: 0.066 }, { floor: 119_700, rate: 0.076 }, { floor: 249_700, rate: 0.0875 }],
  WA: [{ floor: 0, rate: 0.0 }],
  WI: [{ floor: 0, rate: 0.035 }, { floor: 15_110, rate: 0.044 }, { floor: 51_950, rate: 0.053 }, { floor: 332_720, rate: 0.0765 }],
  WV: [{ floor: 0, rate: 0.0222 }, { floor: 10_000, rate: 0.0296 }, { floor: 25_000, rate: 0.0333 }, { floor: 40_000, rate: 0.0444 }, { floor: 60_000, rate: 0.0482 }],
  WY: [{ floor: 0, rate: 0.0 }],
};

export const US_STATES: { code: string; name: string }[] = [
  { code: 'AL', name: 'Alabama' },
  { code: 'AK', name: 'Alaska' },
  { code: 'AZ', name: 'Arizona' },
  { code: 'AR', name: 'Arkansas' },
  { code: 'CA', name: 'California' },
  { code: 'CO', name: 'Colorado' },
  { code: 'CT', name: 'Connecticut' },
  { code: 'DE', name: 'Delaware' },
  { code: 'DC', name: 'District of Columbia' },
  { code: 'FL', name: 'Florida' },
  { code: 'GA', name: 'Georgia' },
  { code: 'HI', name: 'Hawaii' },
  { code: 'ID', name: 'Idaho' },
  { code: 'IL', name: 'Illinois' },
  { code: 'IN', name: 'Indiana' },
  { code: 'IA', name: 'Iowa' },
  { code: 'KS', name: 'Kansas' },
  { code: 'KY', name: 'Kentucky' },
  { code: 'LA', name: 'Louisiana' },
  { code: 'ME', name: 'Maine' },
  { code: 'MD', name: 'Maryland' },
  { code: 'MA', name: 'Massachusetts' },
  { code: 'MI', name: 'Michigan' },
  { code: 'MN', name: 'Minnesota' },
  { code: 'MS', name: 'Mississippi' },
  { code: 'MO', name: 'Missouri' },
  { code: 'MT', name: 'Montana' },
  { code: 'NE', name: 'Nebraska' },
  { code: 'NV', name: 'Nevada' },
  { code: 'NH', name: 'New Hampshire' },
  { code: 'NJ', name: 'New Jersey' },
  { code: 'NM', name: 'New Mexico' },
  { code: 'NY', name: 'New York' },
  { code: 'NC', name: 'North Carolina' },
  { code: 'ND', name: 'North Dakota' },
  { code: 'OH', name: 'Ohio' },
  { code: 'OK', name: 'Oklahoma' },
  { code: 'OR', name: 'Oregon' },
  { code: 'PA', name: 'Pennsylvania' },
  { code: 'RI', name: 'Rhode Island' },
  { code: 'SC', name: 'South Carolina' },
  { code: 'SD', name: 'South Dakota' },
  { code: 'TN', name: 'Tennessee' },
  { code: 'TX', name: 'Texas' },
  { code: 'UT', name: 'Utah' },
  { code: 'VT', name: 'Vermont' },
  { code: 'VA', name: 'Virginia' },
  { code: 'WA', name: 'Washington' },
  { code: 'WV', name: 'West Virginia' },
  { code: 'WI', name: 'Wisconsin' },
  { code: 'WY', name: 'Wyoming' },
];
